import React from "react";
import ClientFooter from "./ClientFooter";

const AboutMe = () => {
    return (
        <>
            <div className="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inner text-center">
                                <h2 className="title">About Me</h2>
                                <ul className="page-list">
                                    <li className="rbt-breadcrumb-item">
                                        <a href="index.html">Home</a>
                                    </li>
                                    <li>
                                        <div className="icon-right">
                                            <i className="feather-chevron-right" />
                                        </div>
                                    </li>
                                    <li className="rbt-breadcrumb-item active">About Me</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="rbt-overlay-page-wrapper">
                <div className="rbt-putchase-guide-area breadcrumb-style-max-width rbt-section-gapBottom">
                    <div className="rbt-article-content-wrapper">
                        <div className="content mt-5">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="about-content">
                                        <h4 className="mb-4">Hi, I'm Venkatesan</h4>
                                        <p className="mb-4">
                                            I'm a full-time options trader with <b>5 years</b> of hands-on experience in the Indian stock market.
                                        </p>

                                        <p className="mb-4">
                                            I'm <b>25 years old</b> and a <b>B.Com graduate</b> who chose trading as a full-time career right after college. Over the years, I've specialized in Nifty options trading, mastering both option buying and option selling. What sets my approach apart is the ability to identify when to buy and when to sell — based on India VIX, market sentiment, and other technical factors.
                                        </p>

                                        <p className="mb-4">
                                            But my journey wasn't smooth. Like many aspiring traders, I struggled in the beginning. I attended multiple workshops and courses hoping to learn — but what I found was disappointing. Most of them lacked real mentorship. They were focused on selling courses, not on building real traders.
                                        </p>

                                        <p className="mb-4">
                                            That's when I decided to become the kind of mentor I wished I had when I started my trading journey.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ClientFooter/>
        </>
    );
};

export default AboutMe; 